import type { DiscoveredRouteModule } from '@/router/generator/types';

const AdminAddressBookView = () => import('@/views/admin/AddressBookView.vue');
export const NAME_ADMIN_ADDRESS_BOOK = 'AdminAddressBook';
export const PATH_ADMIN_ADDRESS_BOOK = 'addressBook';

export const route: DiscoveredRouteModule = {
  id: 'admin.address_book',
  scope: 'admin',
  moduleKey: 'address_book',
  name: NAME_ADMIN_ADDRESS_BOOK,
  path: PATH_ADMIN_ADDRESS_BOOK,
  component: AdminAddressBookView,
  meta: { requiresAdmin: true, dataLoaders: ['project_document', 'features', 'portal_base', 'project_user_fields'] },
};
